import React, { useEffect, useState } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import './AuditDescription.css'
import axios from 'axios'
import Support from '../contact-popup-module/Support'
import { ToastContainer, toast } from 'react-toastify'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions'
import CircularProgress from '@material-ui/core/CircularProgress'
const AuditDescription = () => {
  // const { id } = useParams();
  const location = useLocation()
  const navigate = useNavigate()
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`

  const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`
  const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`
  const backIcon = `${process.env.PUBLIC_URL}/custom-icons/back-button.png`
  const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`
  const downloadIcon = `${process.env.PUBLIC_URL}/custom-icons/download.svg`
  const remark = `${process.env.PUBLIC_URL}/custom-icons/remark.png`
  const audit = location.state.audit
  const userID = location.state.userID
  const activeTab = location.state.activeTab
  console.log('23', activeTab)
  const [dialogWidth, setDialogWidth] = useState('29vw')
  const agentDetails = location.state.agentDetails
  const [formDetails, setFormDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [open, setOpen] = useState(false)
  const [openSharePopup, setOpenSharePopup] = useState(false)
  const [selectedAuditUrl, setSelectedAuditUrl] = useState('')
  const [reqUrl, setReqUrl] = useState(null)
  const audit_id = audit.id
  // const used = audit.used;
  // const make = audit.Make;
  // const model = audit.Model;
  // console.log("used-", used, make, model);
  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth <= 450) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 475) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogWidth('64vw')
      } else if (windowWidth <= 650) {
        setDialogWidth('60vw')
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth('57vw')
      } else if (window.innerWidth <= 875) {
        setDialogWidth('55vw')
      } else if (windowWidth <= 1000) {
        setDialogWidth('48vw')
      } else if (window.innerWidth <= 1100) {
        setDialogWidth('45vw')
      } else if (windowWidth <= 1300) {
        setDialogWidth('40vw')
      } else {
        setDialogWidth('35vw')
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    // Cleanup function to remove event listener
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const hostname = window.location.hostname
    const port = window.location.port
    const baseURL =
      port !== '' ? `https://${hostname}:${port}` : `https://${hostname}`
    setReqUrl(`${baseURL}/audit/inspection/mode/${audit_id}`)
  }, [audit_id])

  const handleCopy = () => {
    navigator.clipboard
      .writeText(selectedAuditUrl)
      .then(() => {
        toast.success('Link Copied!', {
          position: 'bottom-center',
          autoClose: 1000,
          type: 'default',
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          className: 'custom-toast'
        })
      })
      .catch(err => {
        console.error('Failed to copy: ', err)
      })
  }
  // const handleDownloadClick = async (audit_id) => {
  // 	console.log("600", audit_id);

  // 	try {
  // 		const blobName = `downloadedPdf/${audit_id}.pdf`;

  // 		const response = await axios.get('/process_data/fetch-pdf', {
  // 			params: { blobName },
  // 			responseType: 'blob', // Ensures the response is in binary format
  // 		});

  // 		console.log('Response:', response);

  // 		// Create a blob URL and trigger the download
  // 		const blob = new Blob([response.data], { type: 'application/pdf' });
  // 		const url = window.URL.createObjectURL(blob);

  // 		console.log('Blob:', blob);
  // 		console.log('Blob URL:', url);

  // 		// Create a temporary <a> element to trigger download
  // 		const link = document.createElement('a');
  // 		link.href = url;
  // 		link.setAttribute('download', `${audit_id}.pdf`); // Specify the file name
  // 		document.body.appendChild(link);
  // 		link.click();
  // 		document.body.removeChild(link); // Clean up after download

  // 		// Optionally, open the file in the same tab
  // 		window.open(url, '_self');
  // 	} catch (error) {
  // 		console.error('Error fetching and downloading PDF:', error);
  // 	}
  // };

  // useEffect(() => {
  //     console.log(audit);
  //     console.log(userID);
  //     console.log(agentDetails);
  // }, [])

  // const link_to_audit = (audit,) => {
  //     console.log(audit?.mode, 187);
  //     const hostname = window.location.hostname;
  //     const port = window.location.port;
  //     const auditId = audit.id;
  //     // const baseURL = `https://${hostname}:${port}`;
  // 	const baseURL = port !== '' ? `https://${hostname}:${port}` : `https://${hostname}`;
  //     // let url = `/audit/inspection/mode/${auditId}`;
  // 	let url = `${baseURL}/audit/inspection/mode/${auditId}`

  //     // if (audit?.mode === "video") {
  //     //     url = `/audit/video/permission/${auditId}`;
  //     // } else if (audit?.mode === "photo") {
  //     //     url = `/audit/photo/permission/${auditId}`;
  //     // } else {
  //     //     url = `/audit/hybrid/permission/${auditId}`;
  //     // }
  //     return url;
  // };

  const [downloading, setDownloading] = useState({})
//   const handleDownloadClick = audit_id => {
//     setDownloading(prev => ({ ...prev, [audit_id]: true })) // Set downloading state

//     try {
//       const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/downloadedPdf/${audit_id}.pdf?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2026-02-24T13:16:35Z&st=2025-02-24T05:16:35Z&spr=https&sig=nAlMiSVOsiTbyN9VD2KwKfxufU6FTgGvwocFoq4RnZo%3D`

//       // window.location.href = url;
//       window.open(url, '_blank')
//     } catch (error) {
//       console.error('Error redirecting to PDF URL:', error)
//     } finally {
//       setDownloading(prev => ({ ...prev, [audit_id]: false })) // Reset downloading state
//     }
//   }
  //s3
  const handleDownloadClick = async (audit_id) => {
      setDownloading((prev) => ({ ...prev, [audit_id]: true })); // Set downloading state

      try {
          // Prepare blob name based on audit_id
          const blobName = `Insurance_Inspection/downloadedPdf/${audit_id}.pdf`;

          // Call the API to check if document exists and get signed URL
          const response = await fetch('/process_data/check_document_exists', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({ blobName }),
          });

          const data = await response.json();

          if (data.exists && data.url) {
              // Open the signed URL in a new tab
              window.open(data.url, '_blank');
          } else {
              alert('Document does not exist in S3.');
          }
      } catch (error) {
          console.error('Error fetching signed URL:', error);
          alert('Failed to download the document. Please try again later.');
      } finally {
          setDownloading((prev) => ({ ...prev, [audit_id]: false })); // Reset downloading state
      }
  };

  const handleInspectionStart = () => {
    // const url = link_to_audit(audit);
    // console.log(url);
    // navigate(url)
    // // window.location.href = url;
    console.log(reqUrl, 'reqURL')
    window.location.href = reqUrl
  }

//   useEffect(() => {
//     const fetchAuditDetails = async () => {a
//       setLoading(true)
//       try {
//         // Construct the URL with the SAS token
//         const uploadUrl = `https://caiproduction002.blob.core.windows.net/ira/insurance-inspection-details/${audit_id}.json`
//         const sasToken =
//           '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D'

//         // Fetch audit details using axios
//         const auditDetailsFormData = await axios.get(
//           `${uploadUrl}${sasToken}`,
//           { responseType: 'json' }
//         )
//         console.log(auditDetailsFormData.data)

//         // Set the audit details state
//         setFormDetails(auditDetailsFormData.data)
//       } catch (err) {
//         // Handle errors
//         console.error('Error fetching audit details:', err)
//         setError('Failed to fetch audit details.')
//       } finally {
//         setLoading(false)
//       }
//     }

//     // Fetch audit details when the component mounts or audit_id changes
//     if (audit_id) {
//       fetchAuditDetails()
//     }
//   }, [audit_id])
  	useEffect(() => {
      const fetchAuditDetails = async () => {
          setLoading(true);
          try {
              // Construct the S3 object key
              const blobName = `Insurance_Inspection_Details/${audit_id}.json`;

              // Step 1: Get signed URL from backend
              const response = await fetch('/process_data/check_document_exists_others', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({ blobName }),
              });

              const data = await response.json();

              if (data.exists && data.url) {
                
                  // Step 2: Fetch JSON via backend (not directly from S3)
              const backendResponse = await fetch('/process_data/get_s3_json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ url: data.url })
              })

              const backendData = await backendResponse.json()
               
                  
                  setFormDetails(backendData.data);
              } else {
                  setError("Audit details not found in S3.");
              }
          } catch (err) {
              console.error("Error fetching audit details:", err);
              setError("Failed to fetch audit details.");
          } finally {
              setLoading(false);
          }
      };

      if (audit_id) {
          fetchAuditDetails();
      }
  }, [audit_id]);

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleShareClick = audit => {
    console.log('share clicked')

    const auditUrl = reqUrl //link_to_audit(audit); // Generate the audit URL
    setSelectedAuditUrl(auditUrl) // Set the URL for sharing
    setOpenSharePopup(true) // Open the share popup
  }

  const handleShareClose = () => {
    setOpenSharePopup(false) // Close the share popup
  }
  const handleBack = () => {
    // Retrieve userId from localStorage in case it's missing from state
    const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))
    const storedUserId = insuranceUser?.userId
    console.log('storedUserId', storedUserId)

    // Ensure userId is passed when navigating back
    navigate('/auditList', {
      state: {
        userId: location.state?.userId || storedUserId,
        activeTab
      }
    })
  }
  const link_to_audit = audit => {
    console.log(audit?.mode, 187)
    const hostname = window.location.hostname
    const port = window.location.port
    const auditId = audit.id
    // const baseURL = `https://${hostname}:${port}`;
    const baseURL =
      port !== '' ? `https://${hostname}:${port}` : `https://${hostname}`
    // let url = `/audit/inspection/mode/${auditId}`;
    let url = `${baseURL}/audit/inspection/${auditId}`

    // if (audit?.mode === "video") {
    //     url = `/audit/video/permission/${auditId}`;
    // } else if (audit?.mode === "photo") {
    //     url = `/audit/photo/permission/${auditId}`;
    // } else {
    //     url = `/audit/hybrid/permission/${auditId}`;
    // }
    return url
  }

  return (
    <div className='audit-description-container'>
      {/* Header Section */}
      <div className='case-header'>
        <button
          className='back-button'
          // onClick={() => navigate(-1)}
          onClick={handleBack}
        >
          {/* {'<'} */}
          <img src={backIcon} alt='Back' className='button-icon' />
        </button>
        <h1 className='header-title'>Case</h1>
        <button className='info-button' onClick={handleClickOpen}>
          {/* ? */}
          <img src={infoIcon} alt='Info' className='button-icon' />
        </button>
      </div>
      {/* Support Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        className='support-popup-dialog'
      >
        <DialogContent className='support-popup-content'>
          <Support />
          <button onClick={handleClose} className='close-btn'>
            close
          </button>
        </DialogContent>
      </Dialog>

      {/* Audit Card Section */}
      <div className='audit-cards-div'>
        <div className='audit-card-div' key={audit.id}>
          <div className='audit-header-div'>
            <div className='header-one-div'>
              <p className='audit-ids'>{audit.id}</p>
              <div className='date-container-div'>
                <img
                  src={calendar}
                  alt='Calendar Icon'
                  className='calendar-icon-img'
                />
                <p>{audit.date}</p>
              </div>
            </div>

            <div className='header-two-div'>
              {/* <div className="audit-tags-div">
								{audit.type.map((tag, index) => (
									<span key={index} className="audit-tag-section">{tag}</span>
								))}
								{audit.mode &&
									// audit.mode.map((mode, index) => (
									<span className="audit-tag-section">{audit.mode}</span>
									// ))
								}
							</div> */}
              <div className='audit-tags-div'>
                {audit.mode && (
                  <span className='audit-tag'>
                    {audit.mode.charAt(0).toUpperCase() +
                      audit.mode.slice(1).toLowerCase()}{' '}
                    Mode
                  </span>
                )}
              </div>
              <p>{audit.time}</p>
            </div>
          </div>

          <div className='audit-details-div'>
            {/* <p>{agentDetails && agentDetails.FirstName}</p>
						<p>{agentDetails && agentDetails.address}</p> */}
            <h4>{audit['Name of Customer']}</h4>
            <p>
              {/* Client Reference Number :{audit.id || ""} */}
              Client Reference Number :
              {audit['Client Unique Reference No.'] || ''}
            </p>
            <p>
              Vehicle Make/ Model : {audit.Make || ''} {audit.Model || ''}
            </p>
            <p>Vehicle Number : {audit['Vehicle No']}</p>
          </div>

          <div className='audit-actions-div'>
            {activeTab === 'inactive' ? (
              <>
                {audit.used === 'processed' ? (
                  // <button
                  // 	className="download-button"
                  // 	onClick={() => handleDownloadClick(audit.id)}
                  // >
                  // 	Download
                  // 	<img src={downloadIcon} alt="Download Icon" className="download-icon" />
                  // </button>
                  <button
                    className='download-button'
                    onClick={() => handleDownloadClick(audit.id)}
                    disabled={downloading[audit.id]}
                  >
                    {downloading[audit.id] ? 'Downloading...' : 'Download'}
                    <img
                      src={downloadIcon}
                      alt='Download Icon'
                      className='download-icon'
                    />
                  </button>
                ) : audit.used === 'processing' ? (
                  <button className='expired-button' disabled>
                    Used
                  </button>
                ) : (
                  <button className='expired-button' disabled>
                    Expired
                  </button>
                )}
              </>
            ) : (
              <>
                <button
                  className='share-button-div'
                  onClick={() => handleShareClick(audit)}
                >
                  <img
                    src={share}
                    alt='Share Icon'
                    className='share-icon-img'
                  />
                  Share
                </button>
              </>
            )}
          </div>
        </div>

        {/* Share Audit Popup */}
        {/* <Dialog open={openSharePopup} onClose={handleShareClose} className="share-popup-dialog">
					<DialogContent className="share-popup-content">
						<ShareAuditOptions auditUrl={selectedAuditUrl} />
						<button onClick={handleShareClose} className="close-btn">Close</button>
					</DialogContent>
				</Dialog> */}
        <div style={{ position: 'relative' }}>
          <ToastContainer />
          <Dialog
            open={openSharePopup}
            onClose={handleShareClose}
            maxWidth='150vw'
            maxHeight='lg'
            PaperProps={{
              style: {
                width: dialogWidth,
                // padding: "1.5rem 1rem",
                paddingBottom: '0.5rem',
                borderRadius: '4px',
                margin: '0px',
                // height: "242px",
                zIndex: '999999'
              }
            }}
          >
            <DialogTitle
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '1rem',
                fontSize: '1.7rem',
                textAlign: 'center',
                color: 'black',
                // padding: "2rem 0.6rem 1rem 0.6rem",
                fontWeight: '600',
                fontFamily: 'Barlow Condensed'
              }}
            >
              <Typography
                variant='body2'
                color='textSecondary'
                style={{ fontSize: '0.9rem' }}
              >
                Share Inspection link via
              </Typography>
              <ShareAuditOptions auditUrl={selectedAuditUrl} />
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.2rem',
                  border: '1.5px solid #FF0083',
                  padding: '0.2rem 1.2rem',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  width: '100%',
                  cursor: 'pointer'
                }}
                onClick={handleCopy}
              >
                <img
                  src={copy}
                  style={{ width: '1rem', height: '1rem' }}
                  alt='Share Icon'
                />
                <p
                  style={{
                    fontSize: '1rem',
                    fontFamily: "'Montserrat', sans-serif",
                    color: '#FF0083',
                    padding: '0.5rem',
                    cursor: 'pointer'
                  }}
                >
                  Copy url link
                </p>
              </button>
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.2rem',
                  // border: "1.5px solid #FF0083",
                  padding: '0.4rem 1rem',
                  backgroundColor: '#FF0083',
                  borderRadius: '5px',
                  width: '40%',
                  cursor: 'pointer'
                }}
                onClick={handleShareClose}
              >
                <span
                  style={{
                    fontSize: '1rem',
                    fontFamily: "'Montserrat', sans-serif",
                    color: 'white',
                    padding: '0.2rem',
                    cursor: 'pointer'
                  }}
                >
                  Close
                </span>
              </button>
            </DialogTitle>
          </Dialog>
        </div>

        {loading ? (
          <div className='loader'>
            <CircularProgress style={{ color: '#ff0083' }} size={40} />
          </div>
        ) : (
          <div className='case-details'>
            <h2>Case details</h2>

            {/* Remark Section */}

            {activeTab === 'inactive' && audit.used === 'processing' && (
              <div className='remark-box'>
                <div className='remark-header'>
                  <img src={remark} alt='Remark Icon' className='remark-icon' />
                  <span className='remark-title'>Remark</span>
                </div>

                <div className='remark-content'>
                  {/* <strong fontFamily='Barlow Condensed' style={{ color: "rgba(0, 0, 0, 0.87)" }}>Image Quality appropreate</strong> */}
                  <p style={{ fontFamily: 'Montserrat' }}>
                    Inspection Report not generated.
                  </p>
                </div>
              </div>
            )}
            {activeTab === 'inactive' && audit.used === 'accessed' && (
              <div className='remark-box'>
                <div className='remark-header'>
                  <img src={remark} alt='Remark Icon' className='remark-icon' />
                  <span className='remark-title'>Remark</span>
                </div>

                <div className='remark-content'>
                  {/* <strong fontFamily='Barlow Condensed' style={{ color: "rgba(0, 0, 0, 0.87)" }}>Image Quality appropreate</strong> */}
                  <p style={{ fontFamily: 'Montserrat' }}>
                    Inspection not completed.
                  </p>
                </div>
              </div>
            )}
            {/* Case Details Section */}
            <div className='detail-item'>
              <span className='label'>Name</span>
              <span className='content'>{audit['Name of Customer']}</span>
            </div>
            <div className='detail-item'>
              <span className='label'>Email</span>
              <span className='content'>
                {agentDetails && agentDetails.email}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Phone</span>
              <span className='content'>
                {agentDetails && agentDetails.MobileNumber}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Make</span>
              <span className='content'>
                {formDetails && formDetails['Make']}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Model</span>
              <span className='content'>
                {formDetails && formDetails['Model']}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Surveyor Ai Reference No.</span>
              <span className='content'>
                {formDetails && formDetails['Vehicle No']}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Registration no</span>
              <span className='content'>
                {formDetails && formDetails['Vehicle No']}
              </span>
            </div>
            <div className='detail-item'>
              <span className='label'>Audit link</span>
              <span className='content'>
                {audit && (
                  <a
                    href={link_to_audit(audit)}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                      color: ' #333',
                      textDecoration: 'none',
                      fontSize: '12px'
                    }}
                  >
                    {link_to_audit(audit)}
                  </a>
                )}
              </span>
            </div>
          </div>
        )}

        {activeTab !== 'inactive' && (
          <button
            className='start-inspection-button'
            onClick={handleInspectionStart}
          >
            Start inspection
          </button>
        )}
        {activeTab === 'inactive' && audit.used === 'processed' && (
          <button
            className='start-inspection-button'
            onClick={() => handleDownloadClick(audit.id)}
          >
            Download Report
          </button>
        )}
      </div>
    </div>
  )
}

export default AuditDescription
